"use client";

import { AnchorHTMLAttributes, DetailedHTMLProps } from "react";

export default function ClientHref(props: DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
  >) {
  return <a {...props}></a>
}
